export const Label = (label: string) => (
  <>
    {label}
    {' '}
    <sup>*</sup>
  </>
);
